import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import UICardGrid from 'UIComponents/card/UICardGrid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getThemeSections } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import InpageSectionAccordion, { TitleWrapper } from './InpageSectionAccordion';
import { isEmbed } from 'ContentEditorUI/types/Section';
import InpageDraggableThemeSectionContainer from './InpageDraggableThemeSectionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InpageThemeSectionsContainer({
  onDragStart,
  onDragEnd,
  themePath
}) {
  const themeSections = useSelector(getThemeSections);
  if (themeSections.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(InpageSectionAccordion, {
    title: /*#__PURE__*/_jsx(TitleWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "addSectionPanel.customSections.themeSections",
        options: {
          count: themeSections.length
        }
      })
    }),
    type: PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.THEME,
    children: /*#__PURE__*/_jsx(UICardGrid, {
      columns: 1,
      gutterSize: 10,
      className: "m-top-4",
      children: themeSections.map(section => {
        const key = isEmbed(section) ? `${section.id}-${section.name}` : `${section.id}-${section.label}`;
        return /*#__PURE__*/_jsx(InpageDraggableThemeSectionContainer, {
          section: section,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          themePath: themePath
        }, key);
      })
    })
  });
}
InpageThemeSectionsContainer.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
};